
export enum DeviceStatusDto {
    InActive = 'InActive',
    Active = 'Active',
}
export class ResponseCurrentDeviceDto{

    vendorName?: string | undefined;

    modelName?: string | undefined;

    name?: string | undefined;

    status?: DeviceStatusDto;

    description?: string | undefined;

    branchNumber?: number | undefined;

    serialNumber?: string | undefined;

    activeFrom?: Date;

    activeTo?: Date | undefined;

    ProccessingResult?: string | undefined;

}